<!-- src/components/ri3/department/MainDepartment.vue -->
<template>
  <div>
    <v-container fluid>
      <!-- Recherche + création -->
      <div class="d-flex justify-space-between align-baseline mb-4">
        <v-row class="mb-5">
          <v-col cols="12" md="6" style="margin-top: -15px">
          </v-col>
          <v-col cols="12" md="6" class="d-flex justify-end align-center">
            <avs-createButton
              :spantext="$t('actions.create', { entity: $t('commons.department').toLowerCase() })"
              menu
              :label="$vuetify.breakpoint.smAndDown"
              :name="$t('actions.new', { entity: $t('commons.department').toLowerCase() })"
              @click="handleOpenEditDialogByComponent"
            />
            <!-- Bouton Accueil -->
            <v-btn class="ml-2" outlined @click="goToHome" :icon="$vuetify.breakpoint.smAndDown">
              <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-home</v-icon>
              <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('Tableau de bord') }}</span>
            </v-btn>
            <v-btn class="ml-2" outlined @click="goToAdmin" v-if="$store.getters['app/isUserStaff']" :icon="$vuetify.breakpoint.smAndDown">
              <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-security</v-icon>
              <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('Administration') }}</span>
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Organigramme -->
      <template v-if="filteredItems.length">
        <DepartmentOrgChart
          :items="filteredItems"
          :useTreeProgress="true"
          @select="selectDepartment"
        />
      </template>
      <template v-else>
        <div class="d-flex flex-column justify-center align-center" style="height: 60vh;">
          <p class="subtitle-1 mb-4">{{ $t('Aucun département disponible') }}</p>
          <v-btn color="primary" @click="goToHome" :icon="$vuetify.breakpoint.smAndDown">
            <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-home</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('Aller au tableau de bord') }}</span>
          </v-btn>
          <v-btn class="ml-2" outlined @click="goToAdmin" v-if="$store.getters['app/isUserStaff']" :icon="$vuetify.breakpoint.smAndDown">
            <v-icon :left="$vuetify.breakpoint.mdAndUp">mdi-security</v-icon>
            <span v-if="$vuetify.breakpoint.mdAndUp">{{ $t('Administration') }}</span>
          </v-btn>
        </div>
      </template>

      <!-- Dialogs -->
      <v-dialog v-model="editDialogIsOpen" width="40vw">
        <component
          v-model="selectedItem"
          :hasUniqueName="hasUniqueName"
          :is="editDialogContent"
          :isEditable="isEditable"
          @cancel="handleCancel"
          @error="handleError"
          @success="handleSuccess"
        />
      </v-dialog>

      <DeleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Department"
      />
    </v-container>
  </div>
</template>

<script>
import { DepartmentService } from "@/services";
import { mkUnique } from "@/utils/validator";
import DeleteDialog from "@/components/generics/dialogs/DeleteDialog.vue";
import DepartmentEditor from "@/components/ri3/department/DepartmentEditor.vue";
import DepartmentOrgChart from "@/components/ri3/department/DepartmentOrgChart.vue";

export default {
  name: "MainDepartment",
  components: { DeleteDialog, DepartmentEditor, DepartmentOrgChart },
  data() {
    return {
      items: [],
      search: "",
      deleteDialogIsOpen: false,
      editDialogIsOpen: false,
      editDialogContent: null,
      selectedItem: undefined,
      isEditable: true,
    };
  },
  computed: {
    hasUniqueName() {
      const names = this.items
        .filter((e) => e.name !== this.selectedItem?.name)
        .map((e) => e.name);
      return mkUnique(names, "name");
    },
    filteredItems() {
      return this.items.filter((item) =>
        item.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  created() {
    this.fetchDepartments();
    if (this.$store.state.app.project) this.$store.commit("app/clearProject");
  },
  methods: {
    fetchDepartments() {
      const companyPk = this.$store.state.app.company.pk;
      DepartmentService.getDepartment(companyPk).then((response) => {
        this.items = response;
      });
    },
    selectDepartment(p) {
      this.$store.commit("app/setProject", p);
      this.$router.push({ name: "Home" });
    },
    goToHome() {
      this.$router.push({ name: "Home" });
    },
    goToAdmin() {
      this.$router.push({ name: "Admin" });
    },
    handleOpenDeleteDialog(item) {
      this.selectedItem = item;
      this.deleteDialogIsOpen = true;
    },
    handleOpenEditDialog(item) {
      this.selectedItem = item;
      this.handleOpenEditDialogByComponent();
    },
    handleOpenEditDialogByComponent() {
      this.editDialogContent = DepartmentEditor;
      this.editDialogIsOpen = true;
    },
    handleCancel() {
      this.selectedItem = undefined;
      this.deleteDialogIsOpen = false;
      this.editDialogIsOpen = false;
    },
    handleError(message) {
      this.$store.commit("app/message", { msg: message, color: "error" });
    },
    handleSuccess() {
      this.handleCancel();
      this.$nextTick(() => {
        this.fetchDepartments();
        this.$store.commit("app/message", {
          msg: this.$t("messages.success.operation"),
          color: "success",
        });
      });
    },
    handleDelete() {
      DepartmentService.delete(this.selectedItem.id)
        .then(this.handleSuccess)
        .catch((err) => {
          const msg = err.response?.data?.state || err.message;
          this.handleError(msg);
        });
    },
  },
};
</script>

<style scoped>
/* éventuels ajustements globaux */
</style>
